<template>
  <v-touch @swipeup="swipeup" @swipedown="swipedown" class="page-container" ref="pageContent">
    <div class="page-snow"></div>

    <div class="mySwiper-bg" :style="this.bgUrl">
      <!-- swiper滚动整体界面 -->
      <div class="mySwiper-content" :style="this.contentH">
        <swiper class="mySwiper-wp">
          <swiper :options="swiperOption" ref="mySwiper">
            <!-- 第一页滚动 -->
            <swiper-slide>
              <!-- <div class="page-content" v-if="!pageIndex"> -->
              <div class="page-content">
                <div class="page-content-top">
                  <p class="client-name">
                    亲爱的<span class="text-orange">{{ clientInfo.clientName }}</span>,您好
                  </p>
                  <p>
                    小易为您准备的<span class="text-orange">专属感谢信</span>来啦!
                  </p>
                  <p style="margin-top: 15px">重温这一年您在易加网</p>
                  <p>留下了哪些回忆...</p>
                </div>
                <div class="page-content-bottom">
                  <p style="margin-top: 20px"><span class="text-orange">{{ createdDate[0] }}</span>年<span class="text-orange">{{ createdDate[1] }}</span>月<span class="text-orange">{{ createdDate[2] }}</span>日 我们初次相遇</p>
                  <p>
                    感谢您陪我度过<span class="text-orange">{{ spendYear ? spendYear : 0 }}</span>年时光
                  </p>
                  <p>新的一年请多关照</p>
                  <p class="text-msg">底部有惊喜 记得领取哟!</p>
                  <div class="icon-ok"></div>
                </div>
              </div>
            </swiper-slide>

            <!-- 第二页滚动 -->
            <swiper-slide>
              <!-- <div class="page-content" v-if="pageIndex === 1"> -->
              <div class="page-content">
                <div class="page-content-top">
                  <p>
                    您在<span class="text-orange">{{ createdDate[0] }}</span>年<span class="text-orange">{{ createdDate[1] }}</span>月<span class="text-orange">{{ createdDate[2] }}</span>日
                  </p>
                  <p>注册成为易加网会员</p>
                  <p style="margin-top: 20px">加入易加网大家庭已经</p>
                  <p>
                    有<span class="text-orange">{{ spendYear }}</span>年时间啦!
                  </p>
                </div>
                <div class="page-content-bottom">
                  <p style="width: 280px; margin: 20px auto 4px auto;line-height: 25px">
                    感谢您在<span class="text-orange">{{ city }}</span> 城市积极推广博世产品
                  </p>
                  <p>成为我们在市场上最接地气的带盐人</p>
                </div>
              </div>
            </swiper-slide>

            <!-- 第三页滚动 -->
            <swiper-slide>
              <!-- <div class="page-content" v-if="pageIndex === 2"> -->
              <div class="page-content">
                <div class="page-content-top">
                  <div class="pic-goods">
                    <img src="../../assets/images/letter/bg-goods.png" />
                  </div>
                  <p>
                    2019年您为博世覆盖和服务了<span class="text-orange">{{ dataInfo.workshopCount }}</span>家修理厂
                  </p>
                </div>
                <div class="page-content-bottom">
                  <p style="margin: 15px 0 20px 0">
                    占易加网总覆盖率的<span class="text-orange">18</span>%
                  </p>
                  <p>
                    共获得了<span class="text-orange">{{ dataInfo.gainPointSum }}</span>积分，兑换了<span class="text-orange">{{ dataInfo.orderCount }}</span>笔订单
                  </p>
                  <p>
                    消耗了<span class="text-orange">{{ dataInfo.costPointSum }}</span>积分
                  </p>
                </div>
              </div>
            </swiper-slide>

            <!-- 第四页滚动 -->
            <swiper-slide>
              <div class="page-content">
                <div class="page-content-top" style="padding-top: 10px">
                  <p class="first-gift">
                    您兑换的第一件礼品是<span class="text-orange">{{ dataInfo.firstCashItem }}</span>
                  </p>
                  <p class="most-cost">
                    最常兑换的是<span class="text-orange">{{ dataInfo.mostCashItem }}</span>
                  </p>
                  <p class="highest-cost">
                    兑换价值最高的是<span class="text-orange">{{ dataInfo.highestCashItem }}</span>
                  </p>
                  <p style="margin-top: 5px">这些我可都帮您记着呢!</p>
                  <p>综上数据</p>
                </div>
                <div class="page-content-bottom">
                  <div class="prize-img">
                    <img :src="title" />
                  </div>
                  <p>
                    恭喜您获得“<span class="text-orange">{{ dataInfo.title }}</span>”达人称号
                  </p>
                </div>
              </div>
            </swiper-slide>

            <!-- 第五页滚动 -->
            <swiper-slide>
              <div class="page-content page-content-large">
                <div class="page-content-top">
                  <p>记得多与我互动，别让我太孤单</p>
                  <p class="padding-15">最后许个愿望</p>
                  <p>马上抽取属于您的2020年</p>
                  <p>
                    <span class="text-orange">专属福袋</span>吧!
                  </p>
                </div>
                <div class="page-content-bottom">
                  <p class="padding-20" style="padding-top: 20px">福袋来了，100%有奖!</p>

                  <!-- 未参加活动 -->
                  <div class="bag-row" v-if="!clientBagInfo.attendStatus">
                    <div class="bag-list" v-for="(item, index) in bagList" :key="index">
                      <div class="bag-box" :class="{ 'bag-box-click': clickIndex === index }">
                        <div class="bag-title" v-show="clickIndex !== index">
                          {{ item }}
                          <i>!</i>
                        </div>
                        <div
                          v-show="clickIndex !== index"
                          class="bag-btn"
                          @click="clickBag(index)"
                        >点我!</div>
                        <div v-show="clickIndex === index" class="bag-title-click">{{ bagName }}</div>
                        <div v-show="clickIndex === index" class="bag-msg">恭喜你获得</div>
                      </div>
                    </div>
                  </div>
                  <!-- 已参加活动 -->
                  <div class="bag-row-ed" v-else>
                    <div class="bag-list">
                      <div class="bag-box">
                        <div class="bag-title-click" style="color: #fff">{{ bagName }}</div>
                        <div class="bag-msg">恭喜你获得</div>
                      </div>
                    </div>
                  </div>

                  <p style="font-weight: normal;margin-top: 15px;font-size: 14px;">福袋福袋 满满福气!</p>
                </div>

              </div>
            </swiper-slide>
          </swiper>
        </swiper>
      </div>
    </div>

    <div class="swiper-button-next page-btn">
      <div @click="swipeup" v-if="!(pageIndex >= 4)">{{ !pageIndex ? "马上开启感谢信" : "往下翻继续查看" }}</div>
    </div>

    <div class="page-home"></div>
    <div class="page-more" v-if="!(pageIndex >= 4)"></div>
    <div class="page-footer" v-else>活动最终解释权归易加网所有</div>

    <!-- 弹窗-无参加资格 -->
    <van-popup v-model="popShow" class="msg-pop msg-pop-error" :close-on-click-overlay="false">
      <div class="msg-text">{{ errorMsg }}</div>
      <div class="msg-btn">
        <van-button class="msg-btn" type="primary" size="large" @click="popJump">返回易加网首页</van-button>
      </div>
    </van-popup>

    <!-- 弹窗-福袋 -->
    <van-popup v-model="bagShow" class="succeed-msg" :close-on-click-overlay="false">
      <div class="pop-bag-name">{{ this.bagName }}</div>
      <div class="pop-bag-text">恭喜您获得</div>
      <div class="pop-bag-btn" @click="closePop">
        <img src="../../assets/images/letter/btn-get.png" />
      </div>
      <div class="pop-bag-close" @click="closePop">
        <img src="../../assets/images/letter/btn-close.png" />
      </div>
    </van-popup>

  </v-touch>
</template>

<script>
import activityApi from '@/api/activity'
import { userUtils } from '@/utils/auth'
import { commonUtils } from '@/utils/common'
import { Notify } from 'vant'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'ActivityThanksLetter',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      pageIndex: 0,
      clientInfo: {},
      clientBagInfo: {},
      createdDate: [],
      clientHeight: '',
      bagList: ['福哟', '顺哟', '财哟', '旺哟'],
      clickIndex: null,
      bagName: '',
      bagShow: false,
      dataInfo: {},
      bgUrl: {
        backgroundImage: 'url(' + require('../../assets/images/letter/bg-content.png') + ')',
        height: '13.2rem',
        zIndex: '10'
      },
      contentH: {
        height: '7.7333rem'
      },
      popShow: false,
      errorMsg: '',

      // swiper设置
      swiperOption: {
        direction: 'vertical',
        height: 400,
        loop: false,
        speed: 200,
        pagination: {
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next'
        },
        on: {
          slideChangeTransitionStart: () => {
            let index = this.$refs.mySwiper.swiper.activeIndex
            this.pageIndex = index
            // 最后一页
            if (this.pageIndex >= 4) {
              this.bgUrl = { backgroundImage: 'url(' + require('../../assets/images/letter/bg-content-large.png') + ')', height: '16rem', zIndex: '10' }
              this.contentH = { height: '10.4rem' }
              // 之前的页
            } else if (this.pageIndex <= 4) {
              this.bgUrl = { backgroundImage: 'url(' + require('../../assets/images/letter/bg-content.png') + ')', height: '13.2rem', zIndex: '10' }
              this.contentH = { height: '7.7333rem' }
            }
          }
        }
      }
    }
  },

  computed: {
    spendYear () {
      if (!this.dataInfo) {
        return 0
      } else {
        let year = new Date().getFullYear() - this.createdDate[0]
        if (!year) {
          year = 1
        }
        return year
      }
    },

    // 城市-最多显示5个
    city () {
      if (!this.dataInfo.workshopCityName) {
        return
      }
      let cityArr = this.dataInfo.workshopCityName.split(',')
      if (cityArr.length > 6) {
        cityArr.splice(6, cityArr.length, '...')
      }
      return cityArr.join(' ')
    },

    // 称号
    title () {
      if (!this.dataInfo.title) {
        return
      }
      let titleImg = ''
      switch (this.dataInfo.title) {
        case '初露峥嵘':
          titleImg = require('../../assets/images/letter/bg-prize-1.png')
          break
        case '潜力不俗':
          titleImg = require('../../assets/images/letter/bg-prize-2.png')
          break
        case '出类拔萃':
          titleImg = require('../../assets/images/letter/bg-prize-3.png')
          break
        case '叱咤风云':
          titleImg = require('../../assets/images/letter/bg-prize-4.png')
          break
        default:
          break
      }
      return titleImg
    }

  },

  mounted () {
    let htmlDom = document.getElementsByTagName('html')[0]

    // 是否是ios
    let agent = navigator.userAgent
    if (agent.match(/iPhone|ios/i)) {
      htmlDom.style.fontSize = '37px'
    }

    // 暴力解决苹果小屏布局问题
    if (document.documentElement.clientHeight < 660) {
      htmlDom.style.fontSize = '32px'
    }
  },

  created () {
    this.clientInfo = userUtils.getClientInfo()
    if (!this.clientInfo) {
      this.$router.replace({
        name: 'login',
        params: {
          redirectUrl: 'activity-thanks-letter'
        }
      })
    } else {
      this.getClientInfo()
    }
  },

  methods: {
    // 获取用户信息
    getClientInfo () {
      activityApi.getClientInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.clientBagInfo = res.data.resultData.luckyBagRecord
          this.dataInfo = JSON.parse(this.clientBagInfo.jsonData)
          this.dateFormat(this.dataInfo.registerDate)
          if (this.clientBagInfo.attendStatus) {
            this.bagType(this.clientBagInfo.prizeType)
          }
        } else {
          if (res.data.resultCode === 'not-allowed') {
            this.errorMsg = res.data.resultMsg
            this.popShow = true
          } else if (res.data.resultCode === 'not-time') {
            this.errorMsg = res.data.resultMsg
            this.popShow = true
          } else {
            Notify({
              message: res.data.resultMsg,
              background: 'rgba(255, 68, 68, 0.9)',
              className: 'notify-error-msg'
            })
          }
        }
      })
    },

    // 返回首页
    popJump () {
      window.location.href = commonUtils.getExtraSite()
    },

    // 下一页
    swipeup () {
      //   if (!(pageIndex === 4)) {
      //     this.pageIndex--
      //   }
    },

    // 上一页
    swipedown () {
      //   if (this.pageIndex) {
      //     this.pageIndex--
      //   }
    },

    // 点击福袋
    clickBag (index) {
      if (this.clickIndex === null) {
        activityApi.getBag().then(res => {
          if (res.data.resultCode === '0') {
            this.clickIndex = index
            setTimeout(() => {
              this.bagType(res.data.resultData.luckyBag.prizeType)
            }, 400)
            setTimeout(() => {
              this.bagShow = true
            }, 1000)
          }
        })
      }
    },

    // 礼盒分类
    bagType (val) {
      switch (val) {
        case '01':
          this.bagName = '88888积分'
          break
        case '02':
          this.bagName = 'BOSCH GO'
          break
        case '03':
          this.bagName = '开运新年金币'
          break
        case '04':
          this.bagName = '8888积分'
          break
        default:
          break
      }
    },

    // 关闭弹窗
    closePop () {
      this.bagShow = false
      this.clientBagInfo.attendStatus = 1
    },

    // 时间戳格式化
    dateFormat (val) {
      let time = new Date(Number(val))
      this.createdDate.push(time.getFullYear())
      this.createdDate.push(time.getMonth() + 1)
      this.createdDate.push(time.getDate())
    }
  }
}
</script>

<style lang="less" scoped>
// swiper样式
.mySwiper-bg {
  width: 358px;
  background-size: 100% 100%;
  background-repeat: 'no-repeat';
  position: fixed;
  left: 50%;
  margin-left: -178.5px;
  top: 20px;
  z-index: 2;
  box-sizing: border-box;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  .mySwiper-content {
    width: 357px;
    position: absolute;
    top: 205px;
    overflow: hidden;
  }
}

.page-container {
  height: 100%;
  width: 100%;
  background: #1b2786 url('../../assets/images/letter/bg.png') no-repeat;
  background-size: 100% auto;
  position: relative;
  .page-snow {
    width: 100%;
    height: 145px;
    background: url('../../assets/images/letter/bg-snow.png') no-repeat;
    background-size: 100% 100%;
  }
  .page-content {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    p {
      margin-bottom: 5px;
      animation: sport 0.6s ease-in-out 0s 1 normal;
    }
    .padding-15 {
      padding: 15px 0;
    }
    .padding-20 {
      padding-top: 20px;
    }
    .client-name {
      width: 230px;
      margin-left: 63px;
    }
    .first-gift {
      width: 230px;
      margin-left: 63px;
      height: 30px;
      line-height: 16px;
      overflow: hidden;
      font-size: 14px;
    }
    .most-cost {
      width: 240px;
      margin-left: 58px;
      height: 30px;
      line-height: 16px;
      overflow: hidden;
      font-size: 14px;
    }
    .highest-cost {
      width: 256px;
      margin-left: 50px;
      height: 30px;
      line-height: 16px;
      overflow: hidden;
      font-size: 14px;
    }
    .page-content-top {
      height: 170px;
      padding-top: 30px;
      box-sizing: border-box;

      .pic-goods {
        width: 152px;
        height: 105px;
        margin: -15px auto 15px auto;
      }
    }
    .page-content-bottom {
      height: 125px;
      box-sizing: border-box;
      position: relative;

      .icon-ok {
        width: 75px;
        height: 71px;
        background: url('../../assets/images/letter/ok.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 0px;
        right: 30px;
      }
      .text-msg {
        font-size: 12px;
        margin-top: 15px;
        font-weight: normal;
      }
      .prize-img {
        width: 100px;
        height: 78px;
        margin: 5px auto;
      }
      .bag-row,
      .bag-row-ed {
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
        margin-top: 25px;
        .bag-list {
          .bag-box {
            width: 85px;
            height: 111px;
            background: url('../../assets/images/letter/bg-bag.png') no-repeat;
            background-size: 100% 100%;
            text-align: center;
            font-weight: normal;
            .bag-title {
              font-size: 12px;
              color: #fe9f75;
              padding-top: 60px;
            }
            .bag-title-click {
              font-size: 12px;
              color: #fff;
              height: 17px;
              padding-top: 64px;
            }
            .bag-msg {
              font-size: 12px;
              color: #fe9f75;
            }
            .bag-btn {
              width: 60px;
              height: 20px;
              font-size: 12px;
              color: #fe4b01;
              border-radius: 10px;
              line-height: 20px;
              margin: 4px auto;
              background-color: #fff;
            }
          }
          .bag-box-click {
            transition: 0.8s;
            transform: rotateY(360deg);
          }
        }
      }
      .bag-row-ed {
        display: flex;
        justify-content: center;
        padding: 0 10px;
        margin-top: 25px;
      }
    }
  }

  .page-content-large {
    width: 365px;
    background-size: 100% 100%;
    .page-content-bottom {
      height: 225px;
    }
  }

  .page-btn {
    width: 357px;
    height: 62px;
    position: absolute;
    left: 50%;
    margin-left: -178.5px;
    background: url('../../assets/images/letter/bg-btn.png') no-repeat;
    background-size: 100% 100%;
    top: 550px;
    z-index: 2;
    text-align: center;
    line-height: 62px;
    font-size: 20px;
    font-weight: bold;
    color: #333;
  }
  .page-home {
    width: 100%;
    height: 230px;
    position: absolute;
    bottom: 0;
    background: url('../../assets/images/letter/bg-home.png') no-repeat;
    background-size: 100% 100%;
    opacity: 0.7;
    z-index: 1;
  }
  .page-more {
    width: 31px;
    height: 13px;
    position: absolute;
    left: 50%;
    margin-left: -15.5px;
    bottom: 25px;
    background: url('../../assets/images/letter/icon-more.png') no-repeat;
    background-size: 100% 100%;
    z-index: 2;
    animation: icon 0.6s ease-in-out 0.6s infinite alternate;
  }

  .page-footer {
    font-size: 12px;
    color: #fff;
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 20px;
    z-index: 2;
  }

  @keyframes icon {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(10px);
    }
  }

  @keyframes sport {
    0% {
      transform: translateY(15px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
}

.succeed-msg.van-popup {
  width: 268px;
  height: 380px;
  background: url('../../assets/images/letter/bg-popup.png') no-repeat;
  background-size: 100% auto;
  font-weight: normal;
  text-align: center;
  .pop-bag-name {
    color: #fff;
    font-size: 26px;
    margin-top: 160px;
  }
  .pop-bag-text {
    color: #fe9f75;
    font-size: 16px;
    margin-top: 12px;
  }
  .pop-bag-btn {
    width: 175px;
    height: 45px;
    margin: 15px auto 0 auto;
  }
  .pop-bag-close {
    width: 36px;
    height: 36px;
    margin: 40px auto 0 auto;
  }
}

.msg-pop {
  border-radius: 10px;
  text-align: center;
  box-sizing: border-box;
  padding: 8px;
  overflow-y: hidden;
  .msg-text {
    font-size: 14px;
    margin-top: 10px;
    color: #402d26;
    line-height: 22px;
  }
  .msg-btn {
    margin: auto;
    margin-top: 8px;
    width: 110px;
    height: 35px;
    border-radius: 5px;
    line-height: 35px;
    font-size: 14px;
  }
}
.msg-pop-error {
  width: 220px;
  height: 110px;
}

.text-orange {
  color: #fd8805;
}

img {
  width: 100%;
  height: 100%;
}
</style>
